import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const TermsRefund = () => {
  return (
    <div className="terms-refund-page">
      <Navigation />

      <section className="bg-sand text-indigoDeep pt-20 pb-8">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-6">
            <h1 className="font-serif text-4xl mb-4">Refund Policy</h1>
            <div className="text-grayWarm max-w-3xl mx-auto text-left leading-relaxed">
              <p className="mb-4">Your satisfaction is important to us. Here’s how refunds work for our astrology services:</p>

              <ul className="list-disc list-inside mb-4">
                <li className="mb-2">We offer a full refund if you cancel your appointment at least 24 hours in advance.</li>
                <li className="mb-2">Refund requests made less than 24 hours before the appointment may be subject to a partial refund or credit.</li>
                <li className="mb-2">No refunds will be provided for missed appointments or sessions already completed.</li>
              </ul>

              <p className="mb-2">If you experience any issues with your session, please contact us within 48 hours so we can address your concerns.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsRefund;
